import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImgWallOfTrophiesPipe } from '../img-wall-of-trophies.pipe';
import { KindPipe } from '../kind.pipe';
import { RegateDatePipe } from '../regate-date.pipe';
import { RegateRangPipe } from '../regate-rang.pipe';
import { RegateScorePipe } from '../regate-score.pipe';
import { SafePipe } from '../safe.pipe';
import { SeniorityPipe } from '../seniority.pipe';

@NgModule({
  declarations: [SafePipe, KindPipe, SeniorityPipe, RegateScorePipe, RegateRangPipe, RegateDatePipe, ImgWallOfTrophiesPipe],
  imports: [
    CommonModule
  ],
  exports: [
    SafePipe,
    KindPipe,
    SeniorityPipe,
    RegateScorePipe,
    RegateRangPipe,
    RegateDatePipe,
    ImgWallOfTrophiesPipe
  ]
})
export class PipesModule { }
